import { render, staticRenderFns } from "./back-stockorder.vue?vue&type=template&id=390bc2e3&"
import script from "./back-stockorder.vue?vue&type=script&lang=ts&"
export * from "./back-stockorder.vue?vue&type=script&lang=ts&"
import style0 from "./back-stockorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports